import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { Layout } from "../components/Navbar";
import { api } from "../api";
import { toast } from "sonner";

export default function PaymentResult({ ok }) {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState("Verifica pagamento...");
  useEffect(() => {
    if (!ok) { setStatus("Pagamento annullato"); return; }
    const sid = sp.get("session_id"); if (!sid) return;
    let tries = 0;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("Pagamento completato! Prenotazione confermata."); toast.success("Pagato"); setTimeout(()=>nav("/bookings"), 2000); return; }
        if (data.payment_status === "expired" || data.status === "failed") { setStatus("Pagamento fallito"); return; }
      } catch{}
      if (++tries < 30) setTimeout(poll, 2000); else setStatus("Timeout — controlla su Prenotazioni");
    };
    poll();
  }, []);
  return (<Layout><div className="yp-container py-16 text-center">
    <h1 className="text-3xl font-bold mb-6 yp-gradient-text">{status}</h1>
    <button className="yp-btn yp-btn-primary" onClick={()=>nav("/bookings")} data-testid="payment-back-btn">Torna alle prenotazioni</button>
  </div></Layout>);
}
